class YMALRVTabs extends HTMLElement {
    connectedCallback() {
        this.tabButtons = Array.from(this.querySelectorAll('.ymal-rv-tabs-item'));
        this.tabSliderButtons = Array.from(this.querySelectorAll('.ymal-rv-tabs-arrows'));
        this.sliders = Array.from(this.querySelectorAll(".swiper"))
        this.paginationEl = this.querySelector('.swiper-pagination');
        this.tabContents = Array.from(
            this.querySelectorAll('.ymal-rv-tab-content > *')
        ).filter(el => el instanceof HTMLElement);

        if (!this.tabButtons.length || !this.tabContents.length) return;

        this.tabButtons.forEach((btn, index) => {
            btn.addEventListener('click', () => this.setActiveTab(index));
        });

        const idx = this.tabButtons.findIndex(btn => btn.classList.contains('active'));
        const activeIndex = idx >= 0 ? idx : 0;

        this.setActiveTab(activeIndex);
        this.getCurrentProduct();
        this.addRecentlyViewedProduct(this.productId);
        this.addRecentlyViewedHandle(this.productHandle);
        this.getFilteredProducts().then();
        this.initCollectionSlider(activeIndex);
    }

    setActiveTab(index) {
        this.tabButtons.forEach((btn, i) =>
            btn.classList.toggle('active', i === index)
        );

        this.tabSliderButtons.forEach((btn, i) =>
            btn.classList.toggle('active', i === index)
        );

        this.tabContents.forEach((content, i) => {
            const isActive = i === index;
            content.classList.toggle('active', isActive);
        });

        // Init / refresh Recently Viewed slider when its tab becomes visible
        const activeTab = this.tabContents?.[index];
        const rvSliderEl = activeTab?.querySelector?.('.ymal-rv-tab-content__item-slider');
        if (rvSliderEl) {
            this.initSwipers(rvSliderEl);
            try {
                rvSliderEl.swiper?.update?.();
            } catch (e) {
                // ignore
            }
        }

        this.initCollectionSlider(index);
    }

    initSwipers(container) {
        try {
            const containerEl =
                container instanceof Element ? container : this.querySelector(container);
            if (!containerEl) return;
            if (containerEl.dataset.sliderInit === 'true') return;

            const wrapperEl = containerEl.querySelector('.swiper-wrapper');
            const slideCount = wrapperEl?.children?.length || 0;
            // Don't init until slides are present (RV populates async)
            if (slideCount === 0) return;

            const tabIndex = this.tabContents?.findIndex(tab => tab.contains(containerEl)) ?? -1;
            const tabBtn = tabIndex >= 0 ? this.tabButtons?.[tabIndex] : null;
            const dataIndexRaw = tabBtn?.dataset?.index;
            const dataIndex = dataIndexRaw ? Number(dataIndexRaw) : (tabIndex >= 0 ? tabIndex + 1 : null);
            const arrowsContainer = dataIndex
                ? this.querySelector(`.ymal-rv-tabs-arrows[data-index="${dataIndex}"]`)
                : this.querySelector('.ymal-rv-tabs-arrows');

            const nextEl =
                arrowsContainer?.querySelector('[data-recently-slider-next]') ||
                arrowsContainer?.querySelector('[data-slider-next]') ||
                undefined;
            const prevEl =
                arrowsContainer?.querySelector('[data-recently-slider-prev]') ||
                arrowsContainer?.querySelector('[data-slider-prev]') ||
                undefined;

            const paginationEl = arrowsContainer?.querySelector('.swiper-pagination') || undefined;

            new Swiper(containerEl, {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                spaceBetween: 10,
                navigation: {
                    nextEl,
                    prevEl,
                },
                pagination: paginationEl
                    ? {
                        el: paginationEl,
                        clickable: true,
                    }
                    : undefined,
                breakpoints: {
                    0: { slidesOffsetBefore: 0, slidesOffsetAfter: 0, slidesPerView: 2 },
                    990: { slidesOffsetBefore: 0, slidesOffsetAfter: 0, slidesPerView: 4 }
                }
            });
            containerEl.dataset.sliderInit = 'true';
        } catch (e) {
            console.warn('Swiper init skipped');
        }
    }

    initCollectionSlider(index) {
        const tab = this.tabContents?.[index];
        if (!tab) return;

        const sliderEl = tab.querySelector('.featured-collection__slider.swiper');
        if (!sliderEl || sliderEl.dataset.sliderInit === 'true') return;

        const wrapperEl = sliderEl.querySelector('.swiper-wrapper');
        const slideCount = wrapperEl?.children?.length || 0;
        if (slideCount === 0) return;

        const tabBtn = this.tabButtons?.[index];
        const dataIndexRaw = tabBtn?.dataset?.index;
        const dataIndex = dataIndexRaw ? Number(dataIndexRaw) : index + 1;
        const arrowsContainer = this.querySelector(`.ymal-rv-tabs-arrows[data-index="${dataIndex}"]`);
        const nextEl = arrowsContainer?.querySelector('[data-slider-next]') || undefined;
        const prevEl = arrowsContainer?.querySelector('[data-slider-prev]') || undefined;
        const paginationEl = arrowsContainer?.querySelector('.swiper-pagination') || undefined;
        try {
            new Swiper(sliderEl, {
                observer: true,
                observeParents: true,
                watchOverflow: true,
                spaceBetween: 10,
                navigation: {
                    nextEl,
                    prevEl,
                },
                pagination: paginationEl
                    ? {
                        el: paginationEl,
                        clickable: true,
                    }
                    : undefined,
                breakpoints: {
                    0: { slidesOffsetBefore: 0, slidesOffsetAfter: 0, slidesPerView: 2 },
                    990: { slidesOffsetBefore: 0, slidesOffsetAfter: 0, slidesPerView: 4 }
                },
            });
            sliderEl.dataset.sliderInit = 'true';
        } catch (e) {
            console.warn('Collection slider init skipped', e);
        }
    }

    addRecentlyViewedProduct(id) {
        if (!id) return;

        let products = this.getRecentlyViewedProducts() || [];
        id = String(id);
        if (!products.includes(id)) {
            products.unshift(id);
            if (products.length > 8) products.pop();
            this.setCookie('recently_viewed_products', JSON.stringify(products), 30);
        }
    }

    getRecentlyViewedProducts() {
        const raw = this.getCookie('recently_viewed_products');
        if (!raw) return [];
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
        } catch (e) {
            return [];
        }
    }

    addRecentlyViewedHandle(handle) {
        if (!handle) return;

        const safeHandle = String(handle).trim();
        if (!safeHandle) return;

        const handles = this.getRecentlyViewedHandles() || [];
        if (!handles.includes(safeHandle)) {
            handles.unshift(safeHandle);
            if (handles.length > 8) handles.pop();
            this.setCookie('recently_viewed_product_handles', JSON.stringify(handles), 30);
        }
    }

    getRecentlyViewedHandles() {
        const raw = this.getCookie('recently_viewed_product_handles');
        if (!raw) return [];
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
        } catch (e) {
            return [];
        }
    }

    setCookie(name, value, days) {
        try {
            const date = new Date();
            date.setDate(date.getDate() + (days || 30));
            document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
        } catch (e) {
            // ignore
        }
    }

    getCookie(name) {
        const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`));
        if (!cookie) return '';
        const value = cookie.split('=').slice(1).join('=');
        try {
            return decodeURIComponent(value);
        } catch (e) {
            return value;
        }
    }

    async getFilteredProducts() {
        const handles = this.getRecentlyViewedHandles();
        if (handles.length) {
            const search = encodeURIComponent(handles.join(','));
            try {
                const response = await fetch(`/search?q=${search}&type=product&view=products-json`);
                const html = await response.text();

                const tmp = document.createElement('div');
                tmp.innerHTML = html;
                const content = tmp.querySelector('[data-json-response]');
                if (!content) return;

                const wrapper = this.querySelector('.recently-viewed-products__swiper-wrapper');
                if (!wrapper) return;
                wrapper.innerHTML = content.innerHTML;

                content.querySelectorAll('script').forEach((script) => {
                    try {
                        new Function(script.textContent)();
                    } catch (e) {
                        console.warn('Product card script execution failed', e);
                    }
                });

                const activeTab = this.tabContents.find(tab => tab.classList.contains('active'));
                const sliderEl = activeTab?.querySelector('.ymal-rv-tab-content__item-slider');
                if (sliderEl) {
                    // Init after async population, or refresh if already inited
                    if (sliderEl.dataset.sliderInit === 'true' && sliderEl.swiper) {
                        try {
                            sliderEl.swiper.update();
                            sliderEl.swiper.slideTo(0, 0);
                        } catch (e) {
                            // ignore
                        }
                    } else {
                        this.initSwipers(sliderEl);
                    }
                }
            } catch (e) {
                console.warn(e);
            }
            return;
        }

        const ids = this.getRecentlyViewedProducts();
        if (!ids.length) return;

        const search = encodeURIComponent(ids.map(id => `id:${id}`).join(' OR '));

        try {
            const response = await fetch(`/search?q=${search}&type=product&view=products-json`);
            const html = await response.text();

            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const content = tmp.querySelector('[data-json-response]');
            if (!content) return;

            const wrapper = this.querySelector('.recently-viewed-products__swiper-wrapper');
            if (!wrapper) return;
            wrapper.innerHTML = content.innerHTML;

            content.querySelectorAll('script').forEach((script) => {
                try {
                    new Function(script.textContent)();
                } catch (e) {
                    console.warn('Product card script execution failed', e);
                }
            });

            const activeTab = this.tabContents.find(tab =>
                tab.classList.contains('active')
            );
            const sliderEl = activeTab?.querySelector('.ymal-rv-tab-content__item-slider');
            if (sliderEl) {
                if (sliderEl.dataset.sliderInit === 'true' && sliderEl.swiper) {
                    try {
                        sliderEl.swiper.update();
                        sliderEl.swiper.slideTo(0, 0);
                    } catch (e) {
                        // ignore
                    }
                } else {
                    this.initSwipers(sliderEl);
                }
            }
        } catch (e) {
            console.warn(e);
        }
    }

    getCurrentProduct() {
        this.productHandle = this.dataset?.productHandle || '';
        const productJson = document.querySelector('[data-products-json]');
        if (!productJson) return;

        const data = JSON.parse(productJson.innerHTML);
        this.product = data.current_product;

        if (this.product) {
            this.productId = this.product.id;
            if (!this.productHandle && this.product.handle) this.productHandle = this.product.handle;
        }
    }
}

customElements.define('ymal-rv-tabs', YMALRVTabs);
